<template lang="pug">
section.opensite-sec
  .max-container
    .opetitle-wrap
      .arrow-title-img
        img(src='/assets/img/newwebsite/title-arrow-left.png')
      .optitle-box
        .optitle {{ $t('ui.quickSetup') }}
        .optitle-shadow {{ $t('ui.quickSetup') }}
      .arrow-title-img
        img(src='/assets/img/newwebsite/title-arrow-right.png')
    .opensite-step-wrapper
      .stepnumber-wrap
        //- .stepnum.active
        //-   img(src='/assets/img/newwebsite/step-1-icon.png')
        .stepnum.active
          img(src='/assets/img/newwebsite/step-1-icon.png')
        .stepnum
          img(src='/assets/img/newwebsite/step-2-icon-dark.png')
      .step-progress-bar.step2
      .step-caption
        //- .scinfo.active {{ $t('message.choosePackage') }}
        .scinfo.active {{ $t('ui.setUpTheme') }}
        .scinfo {{ $t('ui.checkOut') }}
    .theme-setting-wrapper
      .theme-set-wrap
        .ques-text {{ $t('message.chooseYourPreferedColor') }}
        .theme-color-wrapper(v-if="colorList.length > 0")
          .theme-color-option
            .palette-box(
              v-for="item in colorList"
              @click="selectedDesign(item.theme_color)"
              :class="{ 'default' : loading }"
              :disabled="loading"
              )
              .color-palette-box(
                :class="{ 'active' : colorSelected == item.theme_color }"
              )
                .colbox(:class="item.theme_color + '-1'")
                .colbox(:class="item.theme_color + '-2'")
                .colbox(:class="item.theme_color + '-3'")
          .color-theme-container
            .color-theme-preview
              .color-preview-box
                DisplayLayoutBoxNew(:imageURL="themeSelected + '/' + colorSelected")
            .illus-purpose *{{ $t('message.previewImageForIllustrationOnly') }} {{ $t('message.actualResultMayVary') }}
    .pck-btn-wrap
      button.btn.btn-primary.pcknext-btn(type="button" @click="backStep" :disabled="loading")
        span.prevarw
          i.fas.fa-arrow-left
        | {{ $t('ui.back') }}
      button.btn.btn-primary.pcknext-btn(type="button" @click="nextStep" :disabled="loading")
        | {{ $t('ui.next') }}
        span.nextarw
          i.fas.fa-arrow-right
</template>

<script>
import errorTags from "@/errorTags";
import DisplayLayoutBoxNew from '@/components/siteeditor/newwebsite/model/DisplayLayoutBoxNew.vue'
import config from '@/config'

export default {
  components: {
    DisplayLayoutBoxNew
  },
  props: {
    cartId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      colorList: [],
      colorName: "",
      themeSelected: null,
      colorSelected: null,
      colorDefaultList: config.colorDefaultList
    }
  },
  validations: {},
  computed: {},
  mounted() {},
  methods: {
    reset() {
      this.$v.$reset()
      this.loading = false
      this.colorList = []
      this.colorName = ""
      this.themeSelected = null
      this.colorSelected = null
    },
    cartUiUpdate() {
      let url = config.cartThemeColorUpdateUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        cart_id: this.cartId,
        theme_color: this.colorSelected
      }

      this.loading = true
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.reset();
                var sendData = {
                  cartId: this.cartId,
                  currentStep: 'THEME_COLOR',
                  setUpOpAcc: null
                }
                this.$store.dispatch("user/setSelectedNewWebsite", sendData);
                this.$emit('goStep', 3);
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getCartInfo(cartId) {
      let url = config.cartInfoUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        cart_id: cartId,
        step_name: "UI"
      }

      this.loading = true
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.setVal(response.data.ds);

              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    setVal(data) {
      this.themeSelected = data.cart[0].theme_code
      this.getColorList(this.themeSelected, data.cart[0].theme_color);
    },
    showToast(title, message, variant) {
      this.$swal.fire({
        title: this.$t('ui.' + title),
        html: this.$t('message.' + message),
        icon: variant,
        confirmButtonText: this.$t("ui.ok")
      })
    },
    getColorList(themeCode, color) {
      this.colorSelected = null
      let url = config.getThemeColorListUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        theme_code: themeCode
      }

      this.loading = true
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.colorList = response.data.dt;

                if (color != null) {
                  this.colorSelected = this.colorList.filter(item => item.theme_color == color)[0].theme_color;
                } else {
                  this.colorSelected = this.colorDefaultList[themeCode]
                }

              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    selectedDesign(value) {
      if (this.loading) return;

      this.colorSelected = value;
    },
    doneAll() {
      this.$v.$reset()

      if (this.colorSelected == null) {
        this.$swal.fire({
          title: this.$t('ui.hint'),
          html: this.$t('message.pleaseSelectColor'),
          icon: 'info',
          confirmButtonText: this.$t("ui.ok")
        })
        return false
      }

      return true
    },
    backStep: function () {
      this.$emit('previousStep')
    },
    goStep: function (step) {
      this.$emit('goStep', step)
    },
    async nextStep() {
      if (!this.doneAll())
        return

      this.cartUiUpdate();
    }
  }
}
</script>